<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const handleNextStep = async () => {
  await handleNext('tutorial_terraforming_resources')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.terraformingResources.controlledFrom') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.terraformingResources.decidePlanets') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info">
        {{ t('tutorial.terraformingResources.findImage') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.terraformingResources.done') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>